import {all, call, put, takeLatest} from "redux-saga/effects";
import {normalize, schema} from "normalizr";

import {getErrorMessage} from "utils/sagasErrorHandler";

import {
    getQuotaTypes,
    getQuotaTypesError,
    getQuotaTypesSuccess,
} from "modules/QuotaManager/services/QuotaTypes/actions";
import {
    getQuotaTypesRequest,
} from "modules/QuotaManager/services/QuotaTypes/api";

const quotaTypesSchema = new schema.Entity("types" , {},{ idAttribute: "code" });
const quotaTypesListSchema = new schema.Array(quotaTypesSchema);

//Workers
function* handleGetQuotaTypes({payload}) {
    try {
        const {count, types} = yield call(getQuotaTypesRequest, payload);
        const {result, entities} = normalize(types, quotaTypesListSchema);

        yield put(getQuotaTypesSuccess({
            types: entities.types,
            ids: result,
            count
        }));
    } catch (error) {
        yield put(getQuotaTypesError());
        getErrorMessage(error);
    }
}

// Watchers
export function* quotaTypesSagas() {
    yield all([
        yield takeLatest(getQuotaTypes, handleGetQuotaTypes),
    ]);
}
